<script>
import { mapState } from "vuex";
import Languages from "@/components/widgets/languages";
import { getStoredTheme, setTheme } from "@/state/helpers/theme.helper";

export default {
  locales: {
    pt: {
      'Settings': 'Configurações',
      'My Account': 'Minha Conta',
      'My Address': 'Meus Endereços',
      'Bank Account': 'Conta Bancária',
      'My Password': 'Minha Senha',
      'Password Security': 'Senha de Segurança',
      'Logout': 'Sair',
      'Dark theme': 'Tema escuro',
      'Light theme': 'Tema claro',
    },
    es: {
      'Settings': 'Configuraciones',
      'My Account': 'Mi Cuenta',
      'My Address': 'Mi Endereços',
      'Bank Account': 'Cuenta Bancaria',
      'My Password': 'Mi Contraseña',
      'Password Security': 'Contraseña de Seguridad',
      'Logout': 'Cerrar Sesión',
      'Dark theme': 'Tema oscuro',
      'Light theme': 'Tema claro',
    }
  },
  components: { Languages },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isCondensed: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      avatar: this.$store.state.account.user.avatar,
      isDarkTheme: false,
    };
  },
  mounted() {
    this.isDarkTheme = getStoredTheme() === "dark";
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  created() {
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleAppTheme() {
      const next = getStoredTheme() === "dark" ? "light" : "dark";
      setTheme(next);
      this.isDarkTheme = next === "dark";
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <button id="vertical-menu-btn" class="d-block d-lg-none btn btn-sm px-3 font-size-20 header-item" type="button" @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <router-link tag="a" to="/" class="logo">
          <img style="height:30px;" src="@/assets/images/logo-white.png" />
        </router-link>
      </div>

      <div class="d-flex">
        <Languages class="d-none"></Languages>

        <div class="d-flex align-items-center flex-shrink-0">
          <button
            type="button"
            class="btn btn-link header-item theme-toggle-icon-btn d-flex align-items-center justify-content-center flex-shrink-0 mr-2"
            :title="isDarkTheme ? t('Light theme') : t('Dark theme')"
            :aria-label="isDarkTheme ? t('Light theme') : t('Dark theme')"
            @click="toggleAppTheme"
          >
            <i class="mdi font-size-20" :class="isDarkTheme ? 'mdi-white-balance-sunny' : 'mdi-weather-night'"></i>
          </button>
          <b-dropdown right variant="black" toggle-class="header-item p-2">
          <template v-slot:button-content>
            <img v-if="account.user.avatar" class="rounded-circle header-profile-user" :src="account.user.avatar" alt="" />
            <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=3b3c3d&color=fff&name=' + account.user.name" alt="" />
            <span class="d-none d-xl-inline-block ml-1">{{ account.user.username }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <router-link tag="a" to="/account" class="dropdown-item">
            <span>{{ t('My Account') }}</span>
          </router-link>
          <router-link tag="a" to="/account/documents" class="d-none dropdown-item">
            <span>{{ t('Meus Documentos') }}</span>
          </router-link>
          <router-link tag="a" to="/contracts" class="d-none dropdown-item">
            <span>{{ t('Meus Contratos') }}</span>
          </router-link>
          <router-link tag="a" to="/account/address" class="d-none dropdown-item">
            <span>{{ t('My Address') }}</span>
          </router-link>
          <router-link tag="a" to="/account/pix" class="dropdown-item">
            <span>{{ t('Meu PIX') }}</span>
          </router-link>
          <router-link tag="a" to="/account/password" class="dropdown-item">
            <span>{{ t('My Password') }}</span>
          </router-link>
          <router-link tag="a" to="/account/password/security" class="dropdown-item">
            <span>{{ t('Password Security') }}</span>
          </router-link>
          <div class="dropdown-divider"></div>
          <router-link tag="a" to="/logout" class="dropdown-item mb-2">
            <span>{{ t('Logout') }}</span>
          </router-link>
        </b-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.theme-toggle-icon-btn {
  width: 2.375rem;
  height: 2.375rem;
  min-width: 2.375rem;
  padding: 0 !important;
  border-radius: 50% !important;
  box-shadow: none !important;
  color: #fff !important;
}
</style>
